import { ResponseModel, handleGetAsync, handlePostAsync, handlePutAsync, handleDeleteAsync } from "../../components/common/commonclass";
import { EndPoint } from "../../components/common/config";
import { handleNotify, TOASTER_POSITION, TOASTER_TYPE } from "../../components/common/notification/toaster_notify.component";

var responseModel = new ResponseModel();

export class CategoryService {
    static async getAllCategory(storeId = null) {
        responseModel = new ResponseModel();
        const requestURL = EndPoint.CATEGORY; //endpoint
        const requestModel = { storeId };

        responseModel = await handleGetAsync(requestURL, true, requestModel);
        if (responseModel) {
            return responseModel;
        }
        else {
            console.error('Failed to fetch Category.');
            return [];
        }
    }

    // Create
    static async addNewCategory(data) {
        responseModel = new ResponseModel();
        const requestURL = EndPoint.CATEGORY; // endpoint
        responseModel = await handlePostAsync(requestURL, true, data);

        if (responseModel) {
            handleNotify('Category added successfully!', TOASTER_TYPE.SUCCESS, TOASTER_POSITION.TOP_RIGHT);
            return responseModel;
        } else {
            throw new Error('Failed to create new Category.');
        }
    }


    // Get by ID
    static async getCategoryById(id) {
        responseModel = new ResponseModel();
        const requestURL = `${EndPoint.CATEGORY}/${id}`; // endpoint

        responseModel = await handleGetAsync(requestURL, true);
        if (responseModel) {
            return responseModel;
        } else {
            throw new Error('Failed to fetch Category by ID');
        }
    }

    // Update 
    static async updateCategoryById(id, data) {
        responseModel = new ResponseModel();
        const requestURL = `${EndPoint.CATEGORY}/${id}`; // endpoint
        responseModel = await handlePutAsync(requestURL, true, data);
        if (responseModel) {
            handleNotify('Category updated successfully.', TOASTER_TYPE.SUCCESS, TOASTER_POSITION.TOP_RIGHT);
            return responseModel;
        } else {
            throw new Error('Failed to update Category.');
        }
    }


    // Delete 
    static async deleteCategory(id) {
        responseModel = new ResponseModel();
        const requestURL = `${EndPoint.CATEGORY}/${id}`; // endpoint

        try {
            responseModel = await handleDeleteAsync(requestURL, true);
            if (responseModel) {
                return responseModel;
            } else {
                throw new Error('Failed to delete Category data.');
            }
        } catch (error) {
            console.error('Error deleting Category data:', error);
            throw error;
        }
    }

    // Delete  by IDs
    static async deleteManyCategory(ids) {
        responseModel = new ResponseModel();
        const requestURL = `${EndPoint.CATEGORY}/deletemany`; // endpoint

        responseModel = await handleDeleteAsync(requestURL, true, ids);
        if (responseModel) {
            handleNotify(responseModel, TOASTER_TYPE.SUCCESS, TOASTER_POSITION.TOP_RIGHT);
            return responseModel;
        } else {
            handleNotify(responseModel.error, TOASTER_TYPE.ERROR, TOASTER_POSITION.TOP_RIGHT);
        }
    }
}
